module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "heading-old"
  }, [_vm._v("ON BOARD THE CITACELESTE")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("7. Farouk’s Apartments")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("6. Gynaeceum")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("5. Jetty-Promenade")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("4. Family Opera House")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("3. Thermal Baths")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("2. Hanging Gardens")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("1. Council of Ministers’ Hall")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("0. Embassy of Clairdelune")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("a. Treasury")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("b. Police Station")]), _vm._v(" "), _c('p', {
    staticClass: "first-paragraph-old"
  }, [_vm._v("c. Workshop of Hildegarde & Co.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "map",
      "height": "99%",
      "src": "map.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f25624","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EE_DABOS_CLAIRDELUNE_ebk_00005.vue
// module id = 81
// module chunks = 0